import { DeepPartial } from '@test/mocks';
import React from 'react';
import { ArticleRecord } from '~/config/generated/graphql';
import ArticleCardListBlock from '../../components/ArticleCardListBlock';

interface Props {
  additionalIds?: string[];
  articles?: DeepPartial<ArticleRecord>[];
}

const AdditionalCategoryArticlesBlocks = ({
  additionalIds,
  articles
}: Props) => {
  if (!additionalIds) {
    return <></>;
  }
  if (!articles) {
    return <></>;
  }

  return (
    <>
      {additionalIds.map(id => {
        const articlesList = articles.filter(
          article => String(article?.mainCategory?.id) === id
        );
        return (
          <ArticleCardListBlock
            key={id}
            articles={articlesList}
            heading={articlesList[0]?.mainCategory?.name ?? ''}
            articlesLimit={4}
            categorySlug={articlesList[0]?.mainCategory?.slug ?? ''}
          />
        );
      })}
    </>
  );
};

export default AdditionalCategoryArticlesBlocks;
